const {BlobClient } = require("@azure/storage-blob");
const readOnlySasToken = 'https://criticalmassmao.blob.core.windows.net/$web/entrydata.json?sv=2019-02-02&st=2020-09-07T07%3A57%3A04Z&se=2040-09-08T07%3A57%3A00Z&sr=b&sp=r&sig=ud%2F28SAQYSV5I8jJrCkFVltqkuon77MTsMkRhV4Yl74%3D';
const crypto = require('crypto');

 $( document ).ready(function() 
 {
	const element = document.getElementById('passwordForm');
	if(element != null){
		element.addEventListener('submit', event => 
	{
		event.preventDefault();
		CheckValue();
	});
	CheckValue();
	}
 });

var currentlySelectedPerspective = {index: '', name:''};

function createSHA256Hash(inputString) {
    const hash = crypto.createHash('sha256');
    hash.update(inputString);
    return hash.digest('hex');
}

function CheckValue()
{
	var chosenValue = document.getElementById('passwordInput').value;
	var passwordHash = createSHA256Hash(chosenValue);
	var index = "";
	var name = "";

	getJSON(function(err, data) 
	{
		if (err != null) 
		{
			console.error(err);
			return false;
		} 
		else 
		{
			for (var i = 0; i < data.pairs.length; i++) 
			{
				if(data.pairs[i].paswordValue == passwordHash)
				{
				index = data.pairs[i].index;
				name = data.pairs[i].name;
				break;
				}
			}
					
			if(index != "")
			{
				currentlySelectedPerspective.index = index + "?password=" + chosenValue; 
				currentlySelectedPerspective.name = name;
				$("#perspectiveField").enable().show();
				$("#start-button").enable().show();
				$("#passwordInputContainer").disable().hide();
				$("#perspectiveField").text("Perspectief: " + name);
				
			}else
			{
				currentlySelectedPerspective.index = ''; 
				currentlySelectedPerspective.name = '';
				$("#perspectiveField").disable().hide();
				$("#start-button").disable().hide();
				$("#passwordInputContainer").enable().show();
			}
    	}
	});
}

$.fn.disable = function() {
    return this.each(function() {
        if (typeof this.disabled != "undefined") this.disabled = true;
    });
}

$.fn.enable = function() {
    return this.each(function() {
        if (typeof this.disabled != "undefined") this.disabled = false;
    });
}

export async function getJSON(callback) {

	try{
		// Set this to true if you want to use local passwords instead of passwords from server
		var isDevelopmentMode = false;
		if(isDevelopmentMode){
		fetch('./entrydata.json')
    		.then((response) => response.json())
    		.then((json) => callback(null, json));
		}else{
			const blobClient = new BlobClient(readOnlySasToken);
			const downloadBlockBlobResponse = await blobClient.download();
			const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody);	
			var passwordJson = JSON.parse(downloaded);
		    callback(null, passwordJson);
		}
	}catch(err){
		console.log("Error");
		callback(err);
	}

	async function blobToString(blob) {
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
          fileReader.onloadend = (ev) => {
            resolve(ev.target.result);
          };
          fileReader.onerror = reject;
          fileReader.readAsText(blob);
        });
      }
};

$( document ).ready(function() {
    $('.start-button').on('click',function(){
      ToVideoScene();
    });
 });
 
 function ToVideoScene()
 {
	window.location.href = currentlySelectedPerspective.index;
 }


